module.exports = __webpack_public_path__ + "img/iphone-install-3.9230eec5.jpg";